import { render, staticRenderFns } from "./ventana.vue?vue&type=template&id=09b52d3d&scoped=true"
import script from "./ventana.vue?vue&type=script&lang=js"
export * from "./ventana.vue?vue&type=script&lang=js"
import style0 from "./ventana.vue?vue&type=style&index=0&id=09b52d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b52d3d",
  null
  
)

export default component.exports